import { useCompanyApi } from "~/components/company/composables/useCompanyApi";

// Shared across the screens showing credit insurance: the answer only changes with the user, so it is read once.
const isEnabled = ref(false);
const isLoaded = ref(false);
let loading: Promise<void> | undefined;

export const useCreditInsuranceAccess = () => {
  const { getCreditInsuranceAccess } = useCompanyApi();

  // Hidden unless the API says otherwise: it refuses the credit insurance routes anyway.
  const loadAccess = async () => {
    try {
      isEnabled.value = (await getCreditInsuranceAccess()).isEnabled;
      isLoaded.value = true;
    } catch {
      isEnabled.value = false;
    }
  };

  const ensureAccessLoaded = async () => {
    if (isLoaded.value) return;
    loading ??= loadAccess().finally(() => {
      loading = undefined;
    });
    await loading;
  };

  return { isCreditInsuranceEnabled: readonly(isEnabled), ensureAccessLoaded };
};
